import { jsonldAddressPostalCode } from './JsonldStore';

export const updateJsonldAddressPostalCode = (value) => jsonldAddressPostalCode.update((oldValue) => value);
